import type { ResidentItem } from '@lmc/ts-common'
import { shouldDisplayDnacpr } from '../ResidentProfileScreen/utils/dnacpr'

export const getResidentStatus = (resident: ResidentItem) => {
  switch (resident.status as string) {
    case 'active':
      return 'Active'
    case 'inactive':
      return 'Inactive'
    case 'hospitalised':
      return 'Hospitalised'
    case 'deceased':
      return 'Deceased'
    case 'discharged':
      return 'Discharged'
    case 'transferred':
      return 'Transferred'
    case 'dummy':
      return 'Example'
    default:
      return ''
  }
}

export const getResidentRemarks = (resident: ResidentItem) => {
  const remarks: string[] = []
  if (resident.dols) {
    remarks.push('lps')
  }
  if (shouldDisplayDnacpr(resident.dnacpr, resident.dnacprStartDate)) {
    remarks.push('dnacpr')
  }
  if (typeof resident?.allergies === 'string') {
    remarks.push('allergies')
  }
  return remarks
}

export const matchesSearch = (
  item: ResidentItem,
  statuses: string[],
  zones: string[],
  remarks: string[],
  search: string
) => {
  const fullName = `${item.name.first} ${item.name.last}`

  const hasStatusesSelected = !!statuses?.length

  const hasZonesSelected = !!zones.length

  const hasRemarksSelected = !!remarks.length

  const status = item.status ? item.status : ''

  return (
    !!fullName.match(
      new RegExp(
        (search as string).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
        'i'
      )
    ) &&
    (hasStatusesSelected ? statuses.includes(status) : true) &&
    (hasZonesSelected ? zones.includes(item?.zone as string) : true) &&
    (hasRemarksSelected
      ? remarks.some((remark) => getResidentRemarks(item).includes(remark))
      : true)
  )
}
